// extracted by mini-css-extract-plugin
export default {"root":"QuestionItem_root__4pXWY","header":"QuestionItem_header__DoOHe","score":"QuestionItem_score__jWgLd","padding":"QuestionItem_padding__B4g3K"};